(function() {
    $(document).ready(function() {
        const oIpss = $.extend(true, {}, window.c24.lp.ipssReforged);

        oIpss.filterChipLabelMap.incompleteContract = {
            'singular': 'Anfrage',
            'plural': 'Anfragen',
        };

        oIpss.tileHeadlineMap.incompleteContract = 'Ihre Anfrage';

        oIpss.bCommaAfterPerson = !window.c24LpIsMobile;

        oIpss.bPriceInCents = false;
        oIpss.thousandsSeparator = true;
        oIpss.sDeleteMethod = 'DELETE';

        oIpss.fittingTariffsWithDate = true;

        oIpss.timeWordingMap.incompleteContract = 'erstellt';
        oIpss.bWholeTileClickable = false;

        oIpss.renderPersonDetails = function(data) {
            const labels = { };

            if (!data.inputs && !data.insuredPerson && !data.persons) {
                return labels;
            }

            const persons = data?.insuredPerson ?? data?.inputs?.persons ?? data?.persons;

            if (typeof persons !== 'object' || persons.length === 0) {
                return labels;
            }

            const person = persons[0];

            if (person.job) {
                if (self.bCommaAfterPersonJob) {
                    labels.personJob = person.job + ', ';
                } else {
                    labels.personJob = person.job;
                }
            } else {
                labels.personJob = null;
            }

            if (person.birthday) {
                labels.personBirth = person.birthday;
            } else {
                labels.personBirth = null;
            }

            if (person.benefit) {
                labels.benefit = oIpss.formatPrice(person.benefit, 'euro', false, oIpss.bPriceInCents, oIpss.thousandsSeparator);
            } else {
                labels.benefit = null;
            }

            if (person.terminalAge) {
                labels.terminalAge = person.terminalAge.toString();
            } else {
                labels.terminalAge = null;
            }

            if (person.name || person.firstName || person.lastName) {
                let personName = null;

                if (person.name) {
                    personName = person.name;
                }

                if (!personName) {
                    if (person.firstName && person.lastName) {
                        personName = person.firstName + ' ' + person.lastName;
                    } else {
                        personName = person.firstName ?? person.lastName ?? null;
                    }
                }

                labels.personName = personName;
            } else {
                labels.personName = null;
            }

            return labels;
        };

        oIpss.renderProductSpecificLabels = function (data, sRenderType) {
            const labels = { };
            const dataInputs = sRenderType === 'appointment' ? data : data.inputs;

            if (oIpss.bUseTilesLayout) {

                if (dataInputs.appointmentTime) {

                    labels.messageText = null;

                    labels.terminStatus = 'Termin ändern';
                } else {
                    labels.terminStatus = 'Termin buchen';
                }
            }

            return labels;
        };


        oIpss.renderLabels = function(element, data) {
            if (data.categoryType !== 'contract') {
                if (data.labels.benefit == null && data.labels.terminalAge == null) {
                    $('.insuranceContainer', element).remove();
                }
            }

            $.each(data.labels, function(key, value) {
                if (value != null) {
                    $('.' + key, element).html($.parseHTML(value));
                } else {
                    if (key === 'tariffName') {
                        $('.tariffSeparator', element).remove();
                    }

                    $('.' + key, element).remove();

                    $('.' + key + 'Container', element).remove();
                }
            });
        };


        /**********************************************************
     * Just test data
     **********************************************************/
        // blue teaser with tiles layout
        oIpss.overrideData = {
            'version': 1,
            'lastUpdate': 1579697905,
            'lastSearches': [
                {
                    'time': 1647427103,
                    'deviceOutput': 'mobile',
                    'result': {
                        'cta': {
                            'text': 'Ergebnis anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                        'tariff': {
                            'best': {
                                'period': 'monthly',
                                'price': 6.85,
                            },
                        },
                        'status': {
                            'color': 'gray',
                            'text': 'Vergleich vom 01.01.2024',
                        },
                        'inputs': {
                            'personGroupKey': 'single',
                            'persons': [
                                {
                                    'firstName': 'Anna Carolina',
                                    'type': 'Mich',
                                    'job': 'Bürotätigkeit (kaufmännisch)',
                                    'birthday': '20.05.1980',
                                },
                                {
                                    'firstName': 'Maximilian',
                                    'lastName': 'Wallenberg-Pachaly',
                                    'type': 'Partner',
                                    'job': 'Hausfrau',
                                    'birthday': '02.02.1996',
                                },
                            ],
                            'toDos': [
                                {
                                    'urlDesktop': 'https://**To-do 2**',
                                    'appearance': 'green',
                                    'body': [
                                        '**To-do 2**',
                                        'für ++last serach 1++',
                                        'etc. ...',
                                    ],
                                    'order': 2,
                                },
                                {
                                    'appearance': 'red',
                                    'body': ['To-do 1. für __last serach 1 last serach 1 last serach 1 last serach 1 last serach 1 last serach 1 last serach 1 last serach 1__'],
                                    'order': 1,
                                },
                            ],
                        },
                        'urlDelete': 'https://urlDelete',
                    },
                },
                {
                    'time': 1647427103,
                    'deviceOutput': 'mobile',
                    'result': {
                        'cta': {
                            'text': 'Ergebnis anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                        'tariff': {
                            'best': {
                                'period': 'monthly',
                                'price': 6.85,
                            },
                        },
                        'inputs': {
                            'personGroupKey': 'couple',
                            'persons': [
                                {
                                    'firstName': 'Anna Carolina',
                                    'lastName': 'Quintana Grimaldi Schopf',
                                    'type': 'Mich',
                                    'job': 'Bürotätigkeit (kaufmännisch)',
                                    'birthday': '20.05.1980',
                                },
                                {
                                    'firstName': 'Maximilian',
                                    'lastName': 'Wallenberg-Pachaly',
                                    'type': 'Partner',
                                    'job': 'Hausfrau',
                                    'birthday': '02.02.1996',
                                },
                            ],
                            'toDos': [
                                {
                                    'urlDesktop': 'https://**To-do 2**',
                                    'appearance': 'green',
                                    'body': [
                                        '**To-do 2**',
                                        'für ++last serach 1++',
                                        'etc. ...',
                                    ],
                                    'order': 2,
                                },
                                {
                                    'appearance': 'red',
                                    'body': ['To-do 1. für __last serach 1 last serach 1 last serach 1 last serach 1 last serach 1 last serach 1 last serach 1 last serach 1__'],
                                    'order': 1,
                                },
                            ],
                        },
                        'urlDelete': 'https://urlDelete',
                    },
                },
            ],
            'contracts': [
                {
                    'time': 1647432364,
                    'type': 'offer',
                    'publicId': 'UN-220011450120',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'jetzt online abschließen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                        {
                            'type': 'secondary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                    ],
                    'tariff': {
                        'name': 'Optimal',
                        'period': 'monthly',
                        'price': 9.53,
                    },
                    'insuranceKey': 'ammerlaender',
                    'status': {
                        'color': 'yellow',
                        'text': 'Angebot vom: 16.03.2022',
                    },
                    'inputs': {
                        'persons': [
                            {
                                'firstName': 'Anna Carolina',
                                'lastName': 'Quintana Grimaldi Schopf',
                                'type': 'Mich',
                                'job': 'Bürotätigkeit (kaufmännisch)',
                                'birthday': '20.05.1980',
                            },
                            {
                                'firstName': 'Maximilian',
                                'lastName': 'Wallenberg-Pachaly',
                                'type': 'Partner',
                                'job': 'Hausfrau',
                                'birthday': '02.02.1996',
                            },
                        ],
                    },
                    'info': '200 CHECK24 Punkte vorgemerkt',
                    'deviceOutput': 'mobile',
                    'urlDelete': 'https://urlDelete',
                },
                {
                    'time': 1580111548,
                    'type': 'incompleteContract',
                    'publicId': '71f285ce-30f6-4a0e-a7dc-3d186b2426f9',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'Antrag fortsetzen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                        {
                            'type': 'secondary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                        {
                            'type': 'tertiary',
                            'text': 'Leistungen anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                        {
                            'type': 'quaternary',
                            'text': 'Personen ändern',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                    ],
                    'tariff': {
                        'name': 'Tarif SU Komfort',
                        'period': 'monthly',
                        'price': 16.35,
                    },
                    'inputs': {
                        'persons': [
                            {
                                'lastName': 'Quintana Grimaldi Schopf',
                                'type': 'Mich',
                                'job': 'Bürotätigkeit (kaufmännisch)',
                                'birthday': '20.05.1980',
                            },
                            {
                                'firstName': 'Maximilian',
                                'type': 'Partner',
                                'job': 'Hausfrau',
                                'birthday': '02.02.1996',
                            },
                        ],
                        'toDos': [
                            {
                                'urlDesktop': 'https://für ++offer 1++',
                                'body': [
                                    'To-do 1',
                                    'für ++offer 1++',
                                    'etc. ...',
                                ],
                                'order': 1,
                            },
                            {
                                'urlMobile': 'https://To-do 3',
                                'appearance': 'green',
                                'body': [
                                    'To-do 3',
                                    'für ++offer 1++',
                                    'etc. ...',
                                ],
                                'order': 3,
                            },
                            {
                                'urlDesktop': 'https://To-do 2-urlDesktop',
                                'urlMobile': 'https://To-do 2-urlMobile',
                                'appearance': 'red',
                                'body': ['To-do 2. für offer 1__'],
                                'order': 2,
                            },
                        ],
                    },
                    'insuranceKey': 'devk',
                    'status': {
                        'text': 'Antrag begonnen',
                        'color': 'yellow',
                    },
                    'info': '30 CHECK24 Punkte vorgemerkt',
                    'urlDelete': 'https://urlDelete',
                },
                {
                    'time': 1646131318,
                    'type': 'contract',
                    'origin': 'external',
                    'publicId': 'VEVE-3077264',
                    'urlDelete': 'https://urlDelete',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'vergleichen und wechseln',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                        {
                            'type': 'secondary',
                            'text': 'Details anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                            'urlApp': 'https://urlApp',
                        },
                        {
                            'type': 'tertiary',
                            'text': 'Leistungen anzeigen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                        {
                            'type': 'quaternary',
                            'text': 'Personen ändern',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                    ],
                    'tariff': {
                        'period': 'monthly',
                        'price': 100.00,
                    },
                    'insuranceKey': 'continentale_kv',
                    'status': {
                        'color': 'green',
                        'text': 'Vertrag hinterlegt',
                    },
                    'servicesRating': 'good',
                    'ratingTags': [
                        {
                            'label': 'Leistungen',
                            'rating': 'good',
                        },
                        {
                            'label': 'Preischeck',
                            'rating': 'bad',
                        },
                    ],
                    'info': 'Sparen Sie bis zu 1.142,88 € jährlich bei gleicher Leistung',
                    'inputs': {
                        'personGroupKey': 'single',
                        'persons': [
                            {
                                'type': 'Erwachsener',
                                'job': 'Kaufmann,frau (EDV)',
                                'birthday': '01.01.1980',
                            },
                        ],
                        'toDos': [
                            {
                                'urlDesktop': 'https://To-do 1',
                                'appearance': 'yellow',
                                'body': [
                                    'To-do 1',
                                    'für ++external contract++',
                                    'etc. ...',
                                ],
                                'order': 2,
                            },
                        ],
                    },
                },
            ],
            'staticTiles': [
                {
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'jetzt Vertrag hinzufügen',
                            'urlDesktop': 'primary staticTile URL urlDesktop',
                            'urlMobile': 'primary staticTile URL urlMobile',
                            'urlApp': 'URL',
                            'urlTabletApp': 'URL',
                        },
                    ],
                    'urlDelete': 'https://delete static tile URL',
                },
            ],
            'appointments': [
                {
                    'time': 1694703095,
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'jetzt online abschließen',
                            'urlDesktop': 'primary URL urlDesktop',
                            'urlMobile': 'primary URL urlMobile',
                            'urlApp': 'URL',
                            'urlTabletApp': 'URL',
                            'info': 'Wunschtermin im Kalender auswählen',
                        },
                    ],
                    'consultant': {
                        'persons': [
                            {
                                'gender': 'male',
                                'firstName': 'Max',
                                'lastName': 'Pecu',
                            },
                        ],
                        'image': {
                            'urlDesktop': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/7.png',
                            'urlMobile': {
                                'default': 'https://dummyimage.com/100/ff0000/000000.jpg',
                                'highRes': 'https://dummyimage.com/200/008000/c3c3c3.jpg',
                            },
                            'urlApp': 'https://dummyimage.com/100/ffa500/000000.jpg',
                            'urlTabletApp': 'https://dummyimage.com/100/800080/fff.jpg',
                        },
                    },
                    'appointmentTime': '2023-09-18T04:06:00.000Z',
                },
                {
                    'time': 1694703095,
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'jetzt online abschließen',
                            'urlDesktop': 'primary URL urlDesktop',
                            'urlMobile': 'primary URL urlMobile',
                            'urlApp': 'URL',
                            'urlTabletApp': 'URL',
                            'info': 'Wunschtermin im Kalender auswählen',
                        },
                    ],
                    'consultant': {
                        'persons': [
                            {
                                'gender': 'male',
                                'firstName': 'Max',
                                'lastName': 'Pecu',
                            },
                        ],
                        'image': {
                            'urlDesktop': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/7.png',
                            'urlMobile': {
                                'default': 'https://dummyimage.com/100/ff0000/000000.jpg',
                                'highRes': 'https://dummyimage.com/200/008000/c3c3c3.jpg',
                            },
                            'urlApp': 'https://dummyimage.com/100/ffa500/000000.jpg',
                            'urlTabletApp': 'https://dummyimage.com/100/800080/fff.jpg',
                        },
                    },
                },
            ],
        };
        // oIpss.overrideData = {
        //     'version': 1,
        //     'lastUpdate': 1615894664767,
        //     'lastSearches': [
        //         {
        //             'time': 1725514885,
        //             'deviceOutput': 'desktop',
        //             'result': {
        //                 'cta': {
        //                     'type': 'primary',
        //                     'text': 'Ergebnis anzeigen',
        //                     'urlDesktop': 'https://bu.check24-test.de/result?ba=1500&bal=65&bd=1990-10-15&buRef=P1&et=Berufsausbildung&fow=100&fs=Keine%20Angabe&ind=Sonstige%20Branche&js=Angestellt%2FSelbstst%C3%A4ndig&oc=Industriekaufmann%2Cfrau&sm=false&sr=0',
        //                     'urlMobile': 'https://m.bu.check24-test.de/result?ba=1500&bal=65&bd=1990-10-15&buRef=P1&et=Berufsausbildung&fow=100&fs=Keine%20Angabe&ind=Sonstige%20Branche&js=Angestellt%2FSelbstst%C3%A4ndig&oc=Industriekaufmann%2Cfrau&sm=false&sr=0',
        //                 },
        //                 'tariff': {
        //                     'best': {
        //                         'period': 'monthly',
        //                         'price': 45.36,
        //                     },
        //                 },
        //                 'inputs': {
        //                     'time': 1725514885, // timestamp of the search in Unix format
        //                     'fittingTariffs': 54, // number of fitting tariffs
        //                     'personGroupKey': 'single',
        //                     'persons': [
        //                         {
        //                             'jobSituation': 'Angestellt/Selbstständig',
        //                             'education': 'Berufsausbildung',
        //                             'job': 'Industriekaufmann,frau',
        //                             'birthday': '15.10.1990',
        //                             'benefit': 1500,
        //                             'terminalAge': 65,
        //                             'fractionOfficeWork': 100,
        //                             'staffResponsibility': 0,
        //                             'industry': 'Sonstige Branche',
        //                             'family': 'Keine Angabe',
        //                             'smoker': false,
        //                         },
        //                     ],
        //                 },
        //                 // 'image': {
        //                 //     'urlDesktop': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/7.png',
        //                 // },
        //                 'urlDelete': 'delete URL',
        //             },
        //         },
        //     ],
        //     'contracts': [
        //         {
        //             'time': 1605109841825,
        //             'deviceOutput': 'desktop',
        //             'type': 'contract',
        //             'publicId': 'BU-1095091',
        //             'cta': [
        //                 {
        //                     'type': 'primary',
        //                     'text': 'Details anzeigen',
        //                     'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/uebersicht/alle/details/BU-1095091',
        //                     'urlMobile': 'https://m.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/BU-1095091',
        //                 },
        //             ],
        //             'tariff': {
        //                 'name': 'B1-B NR',
        //                 'period': 'monthly',
        //                 'price': 52.85,
        //             },
        //             'insuranceKey': 'hannoversche_leben',
        //             'inputs': {
        //                 'persons': [
        //                     {
        //                         'name': 'Kraft Stoff',
        //                         'birthday': '26.03.1994',
        //                         'job': 'Betonmischerfahrer,in',
        //                         'benefit': 1000,
        //                         'terminalAge': 60,
        //                     },
        //                 ],
        //             },
        //             'status': {
        //                 'text': 'aktiv: seit 01.12.2020',
        //                 'color': 'green',
        //             },
        //             'info': null,
        //             'urlDelete': 'https://services.bu.check24-test.de/customerareaapi/inquiries/1095091/archive',
        //         },
        //         {
        //             'time': 1605108045732,
        //             'deviceOutput': 'desktop',
        //             'type': 'incompleteContract',
        //             'publicId': 'BU-1095088',
        //             'cta': [
        //                 {
        //                     'type': 'primary',
        //                     'text': 'Details anzeigen',
        //                     'urlDesktop': 'https://www.check24-test.de/versicherungsordner/vertraege/uebersicht/alle/details/BU-1095088',
        //                     'urlMobile': 'https://m.check24-test.de/versicherungsordner/vertraege/ueberblick/alle/details/BU-1095088',
        //                 },
        //             ],
        //             'tariff': {
        //                 'name': 'SBU NR',
        //                 'period': 'monthly',
        //                 'price': 59.09,
        //             },
        //             'insuranceKey': 'volkswohl',
        //             'inputs': {
        //                 'persons': [
        //                     {
        //                         'name': 'Schoko Geschmack',
        //                         'birthday': '24.09.1997',
        //                         'job': 'Hafenarbeiter,in',
        //                         'benefit': 1000,
        //                         'terminalAge': 63,
        //                     },
        //                 ],
        //             },
        //             'status': {
        //                 'text': 'Antrag in Bearbeitung',
        //                 'color': 'yellow',
        //             },
        //             'info': null,
        //             'urlDelete': 'https://services.bu.check24-test.de/customerareaapi/inquiries/1095088/archive',
        //         },
        //     ],
        //     'appointments': [
        //         {
        //             'time': 1694703095,
        //             'cta': [
        //                 // For the new tile layout, we only need one primary CTA, with the text and URL varying based on whether an appointment time exists
        //                 // {
        //                 //     'type': 'primary',
        //                 //     'text': 'Termin ändern',
        //                 //     'urlDesktop': 'primary URL urlDesktop',
        //                 //     'urlMobile': 'primary URL urlMobile',
        //                 //     'urlApp': 'URL', // optional; fallback urlMobile
        //                 //     'urlTabletApp': 'URL', // optional; fallback urlDesktop
        //                 //     'info': 'Wunschtermin im Kalender auswählen',
        //                 // },

        //                 // For the old layout
        //                 {
        //                     'type': 'primary', // blue button
        //                     'text': 'jetzt online abschließen',
        //                     'urlDesktop': 'primary URL urlDesktop',
        //                     'urlMobile': 'primary URL urlMobile',
        //                     'urlApp': 'URL', // optional; fallback urlMobile
        //                     'urlTabletApp': 'URL', // optional; fallback urlDesktop
        //                     'info': 'Wunschtermin im Kalender auswählen',
        //                 },
        //                 {
        //                     'type': 'secondary', // first gray button
        //                     'text': 'Termin ändern',
        //                     'urlDesktop': 'https://desktopapp-verbu-20694.qa.bu.check24-test.de/appointment?inquiryPublicId=8e0ee373-6264-4c7d-887a-0a5eb31735a3',
        //                     'urlMobile': 'https://mobileapp-verbu-20694.qa.bu.check24-test.de/appointment?inquiryPublicId=8e0ee373-6264-4c7d-887a-0a5eb31735a3',
        //                 },
        //                 {
        //                     'type': 'tertiary', // second gray button
        //                     'text': 'Details anzeigen',
        //                     'urlDesktop': 'tertiary URL urlDesktop',
        //                     'urlMobile': 'tertiary URL urlMobile',
        //                     'urlApp': 'URL', // optional; fallback urlMobile
        //                     'urlTabletApp': 'URL', // optional; fallback urlDesktop
        //                 },

        //             ],
        //             'message': {
        //                 'persons': [
        //                     {
        //                         'gender': 'male',
        //                         'firstName': 'Hans',
        //                         'lastName': 'Müller',
        //                     },
        //                 ],
        //                 'salutation': 'Hallo',
        //                 'body': [
        //                     'ich freue mich auf unserer gemeinsamen Termin!',
        //                     'Ihnen ist etwas dazwischen gekommen? Gerne können Sie einen anderen Termin wählen!',
        //                     '++<strong>Hinweis:</strong>: Ihnen ist --etwas-- dazwischen **gekommen**? Gerne __können__ Sie einen __anderen Termin__ wählen!',
        //                 ], // one entry = ein paragraph
        //             },
        //             'consultant': {
        //                 'persons': [
        //                     {
        //                         'gender': 'male', // gender for the consultant
        //                         'firstName': 'Max',
        //                         'lastName': 'Pecu', // optional
        //                     },
        //                 ],
        //                 'image': {
        //                     'urlDesktop': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/7.png', // if only one image version
        //                     'urlMobile': { // if normal and high resolution image
        //                         'default': 'https://dummyimage.com/100/ff0000/000000.jpg',
        //                         'highRes': 'https://dummyimage.com/200/008000/c3c3c3.jpg',
        //                     },
        //                     'urlApp': 'https://dummyimage.com/100/ffa500/000000.jpg', // optional; fallback urlMobile
        //                     'urlTabletApp': 'https://dummyimage.com/100/800080/fff.jpg', // optional; fallback urlDesktop
        //                 },
        //             },
        //             'appointmentTime': '2023-09-18T04:06:00.000Z', // (UTC time as ISO 8601 Standard)
        //         },
        //     ],
        // };
        //
        // lastSearch
        // oIpss.overrideData  = { "lastSearches":[ { "time":1613639577991, "deviceOutput":"desktop", "result":{ "cta":{ "text":"Ergebnis anzeigen", "type":"primary", "urlDesktop":"https://bu.check24-test.de/result?ba=1600&bal=65&bd=1992-01-09&buRef=Q1&et=Studium%20%28Bachelor%29&fow=100&fs=Keine%20Angabe&ind=Sonstige%20Branche&js=Angestellt%2FSelbstst%C3%A4ndig&oc=Drehbuchautor%2Cin&sm=false&sr=0", "urlMobile":"https://m.bu.check24-test.de/result?ba=1600&bal=65&bd=1992-01-09&buRef=Q1&et=Studium%20%28Bachelor%29&fow=100&fs=Keine%20Angabe&ind=Sonstige%20Branche&js=Angestellt%2FSelbstst%C3%A4ndig&oc=Drehbuchautor%2Cin&sm=false&sr=0" }, "inputs":{ "personGroupKey":"single", "persons":[ { "benefit":1600, "birthday":"1992-01-09", "education":"Studium (Bachelor)", "family":"Keine Angabe", "fractionOfficeWork":100, "industry":"Sonstige Branche", "job":"Drehbuchautor,in", "jobSituation":"Angestellt/Selbstständig", "smoker":false, "staffResponsibility":0, "terminalAge":65 } ] }, "tariff":{ "best":{ "period":"monthly", "price":59.62 }, "count":21 }, "urlDelete":null } } ], "contracts":[], "lastUpdate":1613639577991, "version":1 };
        //
        // contract
        // oIpss.overrideData = { "lastSearches":[],"contracts":[ { "time":1605610664444, "deviceOutput":"desktop", "type":"contract", "publicId":"BU-1095584", "cta":[ { "text":"jetzt online abschließen", "type":"primary", "urlDesktop":"https://apps.bu.check24-test.de/customer-area/third-view?inquiryId=1095584" }, { "text":"Neu vergleichen", "type":"secondary", "urlDesktop":"https://apps.bu.check24-test.de/customer-area/third-view?inquiryId=1095584" } ], "tariff":{ "name":"SBU NR", "period":"monthly", "price":34.15 }, "insuranceKey":"volkswohl", "status":{ "color":"green", "text":"aktiv: seit 01.12.2020" }, "info":null, "inputs":{ "personGroupKey":"single", "persons":[ { "birthday":"1998-06-25", "name":"PT c PT c", "benefit":1600, "terminalAge":65 } ] } } ] };
        /**********************************************************/
        /**********************************************************/
        /**********************************************************/

        //oIpss.fadeTeaser = false;
        oIpss.fadeTeaserDelay = 250;

        oIpss.bind('bu', 'https://services.bu' + window.c24LpDomain + '/desktopapi/search-data', $('.mod24ac.bu'));
    });
})();
